module.exports = __webpack_public_path__ + "img/logo-farsi-white.20150414.svg";